"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordAppVersionResult = exports.RecordAppVersionPayload = void 0;
const class_validator_1 = require("class-validator");
const base_update_result_dto_1 = require("../../../../common/dtos/base-update-result.dto");
/**
 * "This is the build I am running." Sent by the app once per load.
 *
 * Deliberately carries no user id — the caller is always reporting about
 * itself, and the handler takes the id from the verified token. A body-supplied
 * id would be a way to write a version onto someone else's row.
 */
class RecordAppVersionPayload {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(64)
], RecordAppVersionPayload.prototype, "appVersion", void 0);
exports.RecordAppVersionPayload = RecordAppVersionPayload;
class RecordAppVersionResult extends base_update_result_dto_1.BaseUpdateResult {
}
exports.RecordAppVersionResult = RecordAppVersionResult;
